export const campaignData = {
  hero: {
    title: "Lebanese Paper Straw Project",
    subtitle: "50,000 Plastic Straws Replaced with Sustainable Alternatives",
    description: "Join Lebanon's leading sustainability initiative. We've replaced 50,000 plastic straws with biodegradable paper alternatives, collaborating with 6+ NGOs and supported by the Lebanese Ministry of Tourism."
  },
  stats: [
    {
      id: 1,
      number: "50,000",
      label: "Plastic Straws Eliminated",
      icon: "leaf"
    },
    {
      id: 2,
      number: "2,500kg",
      label: "Plastic Waste Prevented",
      icon: "recycle"
    },
    {
      id: 3,
      number: "6+",
      label: "Collaborated with NGOs",
      icon: "building"
    },
    {
      id: 4,
      number: "6 Months",
      label: "Campaign Duration",
      icon: "calendar"
    }
  ],
  about: {
    title: "About Our Campaign",
    content: [
      "Our campaign began with a simple yet powerful idea: that sustainability should not only protect our planet, but also strengthen our sense of community. Born in Lebanon, this initiative aims to replace single-use plastics with locally produced biodegradable alternatives, uniting environmental action with national responsibility.",
      "At its heart, the campaign is about turning awareness into action. Each eco-friendly choice becomes an act of solidarity — a reminder that collective progress starts with individual responsibility. Supported by the Lebanese Ministry of Tourism, our project seeks to inspire a new model of civic engagement, where sustainability becomes an expression of pride, culture, and shared purpose.",
      "We believe that true change begins at home. By empowering communities, fostering local innovation, and promoting sustainable habits, we're helping Lebanon move toward a cleaner, prouder, and more resilient future."
    ]
  },
  impact: {
    title: "Real Impact, Real Change",
    points: [
      {
        id: 1,
        title: "Environmental Protection",
        description: "Prevented 2.5 tons of plastic from entering our ecosystem, protecting marine life and reducing pollution."
      },
      {
        id: 2,
        title: "Community Engagement",
        description: "Engaged over 250 businesses and thousands of customers in sustainable practices and environmental awareness."
      },
      {
        id: 3,
        title: "Lasting Change",
        description: "Created a sustainable infrastructure that continues to prevent plastic waste long after the campaign's conclusion."
      }
    ]
  },
  cta: {
    title: "Join the Movement",
    description: "Ready to make a difference in your community?",
    primaryButton: "Get Started",
    secondaryButton: "Learn More"
  }
};